export type Category = 'pio'|'sfx'|'station'|'shift'|'car-part'|'employee'|'car-info'|'qa'|'pio-arg'

type CategoryMap = {
  [key in Category]: string
}

export const categoryMap: CategoryMap = {
  pio: '項目(PIO)',
  sfx: '規格(SFX)',
  station: '工位參數',
  shift: '班別參數',
  'car-part': '組裝區域參數',
  employee: '員工資料',
  'car-info': '車輛資料',
  qa: 'QA已完成資料',
  'pio-arg': '項目(PIO)參數資料'
}
